import { render, staticRenderFns } from "./ChildNavigation.vue?vue&type=template&id=3addc536&scoped=true&"
import script from "./ChildNavigation.vue?vue&type=script&lang=js&"
export * from "./ChildNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ChildNavigation.vue?vue&type=style&index=0&id=3addc536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3addc536",
  null
  
)

export default component.exports